export const messageListAriaLabel = "EmU0Xc";
export const noMoreRowsMessageBarTitle = "xzP_8";
export const noMoreRowsText = "MrAWEe";
export const noMoreRowsSettingButtonText = "SoZqHc";
export default {messageListAriaLabel,noMoreRowsMessageBarTitle,noMoreRowsText,noMoreRowsSettingButtonText};